import { makeStyles } from "@mui/styles";
import { Theme } from "@mui/material/styles/createTheme";

export const useStyles = makeStyles((theme: Theme) => ({
    select: {
        display: "flex",
        alignItems: "flex-end",
        padding: "30px 22px 0px 22px",
        gap: theme.spacing(4),
    },
}));
